import React from 'react';
import { Link } from 'react-router-dom';

const NewsCard = ({ news }) => {
  const isExternal = news?.content?.indexOf('redirect_to_url') === 0;
  const href = isExternal ? news.content.replace('redirect_to_url=', '') : news.link;

  return (
    <div className="news-card-v2 h-100">
      <div className="news-card-v2__header">
        <span className="news-card-v2__category">{news.category || 'News'}</span>
        <span className="news-card-v2__date">{news.date}</span>
      </div>
      <h4 className="news-card-v2__title" title={news.title}>
        {isExternal ? (
          <a href={href} className="news-card-v2__title-link" target="_blank" rel="noopener noreferrer">
            {news.title}
          </a>
        ) : (
          <Link to={href} className="news-card-v2__title-link">
            {news.title}
          </Link>
        )}
      </h4>
      {isExternal ? (
        <a href={href} className="news-card-v2__cta" target="_blank" rel="noopener noreferrer">
          Read More <span className="news-card-v2__cta-arrow">➔</span>
        </a>
      ) : (
        <Link to={href} className="news-card-v2__cta">
          Read More <span className="news-card-v2__cta-arrow">➔</span>
        </Link>
      )}
    </div>
  );
};

export default NewsCard;